import { NextPage } from 'next'
import dynamic from 'next/dynamic'
import { getIDeviceComponent } from '@ucheba/utils/helpers/components'
import { IObjectDevicesComponents } from '@ucheba/utils/helpers/components/types'
import React from 'react'
import { NextSeo } from 'next-seo'
import { eventsSearchSelectors } from '@ucheba/store/events/search'
import { useSelector } from 'react-redux'
import { IEventsPageProps } from './types'
import { useEventsSeoData } from './bll'

const devicesPages: IObjectDevicesComponents = {
  desktop: dynamic(() => import('./desktop')),
  touch: dynamic(() => import('./touch')),
}

const EventsPage: NextPage<IEventsPageProps> = (props) => {
  const { content, query } = props

  const { titleWithQuery, descriptionWithQuery, years, isIndexAndFollow } =
    useEventsSeoData(query)

  const searchResults = useSelector(eventsSearchSelectors.entity)

  return (
    <>
      <NextSeo
        title={`${content.seo.meta.title}: ${titleWithQuery} ${years}`}
        description={descriptionWithQuery}
        noindex={!isIndexAndFollow}
        nofollow={!isIndexAndFollow}
        openGraph={{
          title: `${content.seo.meta.title}: ${titleWithQuery}`,
          description: descriptionWithQuery,
          images: [
            {
              url: 'https://www.ucheba.ru/pix/upload/articles/img___dod_ucheba.png',
              width: 1200,
              height: 630,
            },
          ],
        }}
      />

      {getIDeviceComponent({ ...props, titleWithQuery, searchResults }, devicesPages)}
    </>
  )
}

export default EventsPage
